module.exports = __webpack_public_path__ + "static/media/11.Highlighted Spread.024c604b.jpg";